export const CONFIG = {
    api : 'http://easycare.dev.fegno.com/api/v1/' ,
    dateFormat: "DD MMM YYYY",
}